/**
 * Typed client wrappers for the insurance module.
 * Após a migration 20260510140000 estar aplicada, os types.ts são
 * regenerados automaticamente pelo Lovable Cloud, pelo que já não
 * precisamos de casts `as any`.
 */
import { supabase } from "@/integrations/supabase/client";

export const sb = supabase;

export const insuranceTables = {
  requests: () => supabase.from("insurance_requests"),
  media: () => supabase.from("insurance_media"),
  companies: () => supabase.from("insurance_companies"),
  agents: () => supabase.from("insurance_company_agents"),
  policies: () => supabase.from("insurance_policies"),
  renewals: () => supabase.from("insurance_renewals"),
  auditLog: () => supabase.from("insurance_audit_log"),
  invoices: () => supabase.from("insurance_invoices"),
};
